export const container = ({ theme: { colors } }) => ({
    marginBottom: '3.625rem',
    top: '2rem',
    position: 'relative',
    backgroundColor: colors.form.bgGrey,
    border: `1px solid ${colors.form.borderGrey}`,
    height: '3.625rem',
});

export const input = ({ theme: { colors, fonts } }) => ({
    backgroundColor: colors.form.bgGrey,
    border: 'none',
    width: '100%',
    padding: '1.375rem 1.125rem 0.5rem 1.125rem',
    fontSize: '1.125rem',
    ...fonts.heroNewMedium,
    boxSizing: 'border-box',

    opacity: 0,
    position: 'absolute',
    left: 0,
    zIndex: 2,
});

export const label = ({ theme: { colors } }) => ({
    width: '100%',
    position: 'relative',
    display: 'block',

    transition: 'cubic-bezier(0.4, 0.0, 0.2, 1) color 0.3s',
    willChange: 'color',

    ':hover': {
        '& button': {
            color: colors.fuchsia,
        },
    },
});

export const labelText = ({ theme: { colors }, active, value }) => ({
    color: colors.darkGrey,
    fontSize: '1.125rem',
    transition:
        'cubic-bezier(0.4, 0.0, 0.2, 1) width 0.3s, cubic-bezier(0.4, 0.0, 0.2, 1) top 0.3s, cubic-bezier(0.4, 0.0, 0.2, 1) font-size 0.3s',
    willChange: 'font-size, bottom',
    opacity: !active && value && value.length > 0 ? 0 : 1,
    position: 'relative',
    top: '-2rem',
});

export const errors = ({ theme: { colors } }) => ({
    position: 'absolute',
    fontSize: '0.75rem',
    left: '1.125rem',
    color: colors.red,
    bottom: '-1.5rem',
});

export const button = ({ theme: { colors } }) => ({
    color: colors.blue,
    fontSize: '1rem',
    fontWeight: 'bold',
    borderBottom: `0.125rem solid ${colors.blue}`,
    position: 'absolute',
    left: '1.125rem',
    top: '1.3rem',

    transition: 'cubic-bezier(0.4, 0.0, 0.2, 1) color 0.3s',
    willChange: 'color',

    ':hover': {
        color: colors.fuchsia,
    },
});

export const removeIcon = ({ theme: { colors } }) => ({
    fill: colors.red,
    width: '2rem',
});

export const removeButton = {
    height: '2rem',
    position: 'absolute',
    right: '2.25rem',
    top: '0.9rem',
    zIndex: 3,
};
